import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Wallet, Plus } from 'lucide-react';


export default function BottomNav() {

    const location = useLocation();
    const history = useHistory();
    const path = location.pathname;

    const isActive = (route: string) => path.includes(route);

    const navItems = [
        { route: '/admin/pos', icon: Plus, label: 'POS', rotate: true },
        { route: '/admin/dashboard', icon: Home, label: 'Dashboard', rotate: false },
        { route: '/admin/settings', icon: Wallet, label: 'Settings', rotate: false },
    ];

    return (
        <>
            {/* Bottom Nav Bar — hidden on desktop (sidebar takes over) */}
            <div className="fixed bottom-6 left-1/2 -translate-x-1/2 w-[300px] z-40 pointer-events-none lg:hidden">
                <div className="backdrop-blur-md border rounded-[2rem] px-4 h-16 flex items-center justify-around shadow-2xl pointer-events-auto" style={{ background: 'var(--nav-bg)', borderColor: 'var(--nav-border)' }}>

                    {navItems.map(({ route, icon: Icon, rotate }) => {
                        const active = isActive(route);
                        return (
                            <motion.button
                                key={route}
                                whileTap={{ scale: 0.82, rotate: rotate && !active ? 90 : 0 }}
                                transition={{ type: 'spring', stiffness: 400, damping: 20 }}
                                onClick={() => history.push(route)}
                                className="relative flex items-center justify-center w-14 h-12 rounded-2xl cursor-pointer border-none bg-transparent"
                            >
                                <motion.div
                                    className="absolute inset-0 rounded-2xl bg-blue-500"
                                    animate={{ opacity: active ? 1 : 0, scale: active ? 1 : 0.7 }}
                                    transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                                    style={{ zIndex: 0 }}
                                />
                                <motion.div
                                    className="relative z-10"
                                    animate={{ scale: active ? 1.1 : 1 }}
                                    transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                                >
                                    <Icon
                                        size={22}
                                        className={active ? 'text-white' : 'text-txt-muted'}
                                        strokeWidth={active ? 2.5 : 1.8}
                                    />
                                </motion.div>
                            </motion.button>
                        );
                    })}

                </div>
            </div>
        </>
    );
}
